import { getAppBFFUrl } from "../functions";
import { getTenant } from "./api";

type CheckDigaCodeResult = { valid: true } | { valid: false; error: string };

const localizedMessages: Record<
  string,
  { invalidCode: string; serviceUnavailable: string; invalidTenant: string }
> = {
  "de-DE": {
    invalidCode: "Der Code ist ungültig oder wurde bereits verwendet.",
    serviceUnavailable:
      "Der Service ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.",
    invalidTenant: "Ungültige Produktkonfiguration.",
  },
  "fr-FR": {
    invalidCode: "Le code est invalide ou a déjà été utilisé.",
    serviceUnavailable:
      "Le service est actuellement indisponible. Veuillez réessayer plus tard.",
    invalidTenant: "Configuration du produit invalide.",
  },
};

function getMessages(locale?: string | null) {
  return localizedMessages[locale ?? "de-DE"] ?? localizedMessages["de-DE"];
}

export const checkDigaCode = async (
  digaCode: string,
): Promise<CheckDigaCodeResult> => {
  const locale = window.sessionLayer?.lead?.form_client?.locale;
  const messages = getMessages(locale);

  const tenant = getTenant();
  if (!tenant) {
    return { valid: false, error: messages.invalidTenant };
  }

  const baseUrl = await getAppBFFUrl();

  try {
    const res = await fetch(`${baseUrl}/payment/api/v1/public/diga/check`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-tenant": tenant,
      },
      body: JSON.stringify({ diga_code: digaCode }),
    });

    if (res.status === 503) {
      return { valid: false, error: messages.serviceUnavailable };
    }

    if (!res.ok) {
      return { valid: false, error: messages.serviceUnavailable };
    }

    const data = await res.json();
    if (data.valid) {
      return { valid: true };
    }
    return { valid: false, error: messages.invalidCode };
  } catch {
    return { valid: false, error: messages.serviceUnavailable };
  }
};
